import React from "react";
import { DownloadUserProvider } from "./DownoadUserContext";
import DownloadUserAccountForm from "./DownloadUserAccountForm";

const DownloadUserPage = () => {
  return (
    <DownloadUserProvider>
      <DownloadUserAccountForm />
    </DownloadUserProvider>
  );
};

export default DownloadUserPage;
